import dynamic from './modules/dynamic'
import dynamicHome from './modules/dynamicHome'
import dynamicMy from './modules/dynamicMy'

export default {
  dynamic,
  dynamicHome,
  dynamicMy,
}



// WEBPACK FOOTER //
// ./src/store/dynamic/index.js